import { Link } from '@mui/material';
import { LinkProps } from '@mui/material/Link/Link';
import { NavLink } from 'react-router-dom';

import { usePortalLinkContext } from '~/components/PortalLink/context';

type PropsType = LinkProps<NavLink> & {
  href?: string;
};

export const PortalLink = (props: PropsType) => {
  const { href, ...linkProps } = props;

  const { isRouteLinksEnabled } = usePortalLinkContext();

  // Legacy UI or external link
  if (href) {
    return <Link href={href} {...linkProps} />;
  }

  // Link in Library Package component context
  if (!isRouteLinksEnabled) {
    return <Link href={`/v2${linkProps.to}`} {...linkProps} />;
  }

  return <Link component={NavLink} {...linkProps} />;
};
